import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SupportedLanguage, TranslationService } from '../../services/translation/translation.service';

@Component({
  selector: 'ccp-language-switcher',
  standalone: true,
  imports: [CommonModule, MatButtonModule, MatMenuModule, MatIconModule, MatTooltipModule],
  templateUrl: './language-switcher.component.html',
  styleUrls: ['./language-switcher.component.scss'],
})
export class LanguageSwitcherComponent {
  readonly translationService = inject(TranslationService);

  selectLanguage(lang: SupportedLanguage): void {
    this.translationService.setLanguage(lang);
  }
}
